import * as React from 'react';
import "./SelectElement.scss";
import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { ElementType } from '../../common/enum/elementType';
import InputElement from '../core/InputElement';
import { SelectProps, SelectDefines } from './ISelect';
import useActionExecutor from '../service/actionExecutor';
import { ColorDefines } from '../../interface/IColors';

interface SelectElementProps {
  props: SelectProps;
  defines: SelectDefines;
  colors: ColorDefines;
}

interface SelectItemProps {
  name: string;
  label: string;
}

const SelectElement = ({ props, defines, colors }: SelectElementProps) => {
  const [touched, setTouched] = useState(false);
  const getLabelByOptions = useCallback((value: string) => {
    if (value == null) return "";
    return defines.options.find(opt => opt.value == value)?.label || "";
  }, [defines.options]);
  const [value, setValue] = useState<SelectItemProps>({
    label: getLabelByOptions(props.value || defines.defaultValue),
    name: props.value || defines.defaultValue
  });
  const { change } = useActionExecutor(props.event, defines);

  useEffect(() => {
    if (props.value) {
      setValue({
        label: getLabelByOptions(props.value || defines.defaultValue),
        name: props.value || defines.defaultValue
      });
    }
    return () => {
      setValue(undefined);
    }
  }, [props.value, defines.defaultValue, defines.options]);

  const defaultOption = defines.defaultOptionItem ? 
    <option
      className="default-option"
      value={defines.defaultOptionItem.value}
      hidden
    >{defines.defaultOptionItem?.label || "-"}</option> :
    <></>;

  const setTouchedWrapper = (v: boolean) => {
    setTouched(v);
    if (props.setTouched) props.setTouched(v);
  };

  const onchange = (e: ChangeEvent<HTMLSelectElement>) => {
    setTouchedWrapper(true);
    const v = e.target.value;
    setValue({ label: getLabelByOptions(v), name: v });
    if (change) change(e);
  };
  return (
    <InputElement
      type={ElementType.SELECT}
      value={value?.name}
      touched={touched}
      dispatchValid={props.dispatchValid}
      {...{ props, defines }}
    >
      <select
        name={defines.name}
        value={value?.name}
        onBlur={_ => setTouchedWrapper(true)}
        onChange={onchange}
        disabled={!defines.options || defines.options.length == 0}
        className={null == value ? "default" : ""}
      >
        {!value?.name && defaultOption}
        {(defines.options || []).map((opt, i) => {
          return (<option
            key={i}
            value={opt.value}
          >{opt.label}</option>)
        })}
      </select>
    </InputElement>
  );
}

export default SelectElement;